import styled from "styled-components";

export const Container = styled.div`
  max-width: 800px;
  padding: 0 12px;
  margin: 0 auto;
`;
